import * as Sentry from "@sentry/nextjs";
import { isSentryEnabled } from "./sentryEnabled";

/** Log and send an error to Sentry (API routes, sockets, client catches). */
export function reportError(message: string, error: unknown, extra?: Record<string, unknown>): void {
  console.error(message, error);
  if (!isSentryEnabled()) return;
  Sentry.captureException(error, {
    extra: { message, ...extra },
  });
}
